import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      next_event: {
        "title": "Prochaine soirée",
        "agenda": "Tout l’agenda",
        "loading": "Chargement des prochaines dates…",
        "error": "Les prochaines dates sont momentanément indisponibles.",
        "retry": "Réessayer",
        "openair": "Open Air",
        "monthly": "Soirée au club",
        "book": "Prendre mes billets",
        "sold_out": "Complet",
        "soon": "Billetterie bientôt disponible",
        "empty_title": "Prochaine date bientôt annoncée",
        "empty_text": "La prochaine fête se prépare. Retrouvez ici les nouvelles dates et leur billetterie dès leur annonce.",
        "follow": "Suivre nos annonces"
      },
      // Navigation
      nav: {
        home: 'Accueil',
        agenda: 'Agenda',
        histoire: 'Histoire',
        videos: 'Vidéos',
        galerie: 'Galerie',
        ideologie: 'Idéologie',
        experience: 'Expérience',
        booking: 'Réserver VIP',
        tickets: 'Tickets'
      },
      // Hero
      hero: {
        title: 'INVASION LATINA',
        subtitle: 'OPEN AIR 2026',
        tagline: "C'est pas un festival. C'est notre été.",
        date: 'Samedi 11 Juillet',
        location: 'Place du Congrès • Bruxelles',
        cta_tickets: 'Prendre mes tickets',
        cta_discover: 'Découvrir'
      },
      // Countdown
      countdown: {
        title: 'L\'Open Air commence dans',
        days: 'Jours',
        hours: 'Heures',
        minutes: 'Minutes',
        seconds: 'Secondes',
        event_started: 'L\'evenement a commence !'
      },
      // Tickets
      tickets: {
        title: 'TICKETS',
        subtitle: 'Sécurise ta place à l\'Open Air 2026',
        sold_out: 'SOLD OUT',
        available: 'DISPONIBLE',
        coming_soon: 'BIENTÔT',
        buy: 'Acheter'
      },
      // Experience
      experience: {
        title: 'L\'EXPÉRIENCE',
        subtitle: 'Vis l\'Invasion',
        music: 'Musique',
        music_desc: 'Reggaeton, Latin Trap, Afrobeats, Dancehall',
        decor: 'Décors',
        decor_desc: 'Scénographie immersive, LED screens, lumières',
        community: 'Communauté',
        community_desc: 'La familia se réunit. 7 000 personnes.',
        years: 'ans',
        people: 'personnes',
        hours: 'heures de musique',
        one_place: '1 seul lieu',
        intro_1: 'L\'expérience Invasion Latina, c\'est bien plus qu\'une soirée. C\'est une immersion totale dans la culture latine, un moment de pure énergie où',
        intro_familia: 'la familia',
        intro_2: 'se retrouve pour vivre des moments inoubliables.',
        sounds_title: 'Les Sons de l\'Invasion',
        stat_years: 'Années',
        stat_people: 'Personnes',
        stat_hours: 'De musique',
        stat_djs: 'DJs',
        cta_title: 'Prêt à vivre l\'expérience ?',
        cta_subtitle: 'Rejoins la familia le 11 juillet 2026',
        cta_tickets: 'Prendre mes tickets →',
        cta_vip: 'Réserver VIP'
      },
      // VIP Booking
      booking: {
        title: 'RÉSERVER UNE TABLE VIP',
        subtitle: 'Vivez l\'expérience VIP avec votre groupe',
        name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone (WhatsApp)',
        event: 'Événement',
        guests: 'Nombre de personnes',
        message: 'Message (optionnel)',
        submit: 'Envoyer la demande',
        whatsapp: 'Contacter via WhatsApp',
        success: 'Demande envoyée avec succès !',
        error: 'Une erreur est survenue. Veuillez réessayer.'
      },
      // Videos
      videos: {
        title: 'REVIVEZ L\'INVASION',
        subtitle: 'Nos meilleurs moments en vidéo',
        all: 'Tous',
        aftermovies: 'Aftermovies',
        aftermovie: 'Aftermovie',
        teasers: 'Teasers',
        teaser: 'Teaser',
        openair: 'Open Air',
        mirano: 'Mirano',
        all_types: 'Tous les types',
        all_categories: 'Toutes les catégories',
        type: 'Type',
        category: 'Catégorie',
        no_videos: 'Aucune vidéo disponible.'
      },
      // Spotify
      spotify: {
        title: 'LA PLAYLIST',
        subtitle: 'Le son d\'Invasion Latina',
        open_in_spotify: 'Écouter sur Spotify',
        play_button: 'Écouter la playlist',
        close: 'Fermer'
      },
      // Ideology
      ideology: {
        title: 'NOTRE PHILOSOPHIE',
        subtitle: 'L\'Invasion, c\'est aussi...',
        slogan: 'Respect. Sécurité. Familia.',
        respect: 'Respect',
        respect_desc: 'Chacun est le bienvenu, sans exception. Zéro tolérance pour toute forme de discrimination.',
        security: 'Sécurité',
        security_desc: 'Équipe de sécurité professionnelle, espaces de décompression.',
        consent: 'Consentement',
        consent_desc: 'Le respect du corps et de l\'espace de chacun est non-négociable.',
        safe_space: 'Safe Space',
        safe_space_desc: 'Tu te sens mal ? Approche notre équipe (t-shirt Invasion). On est là.',
        prevention: 'Prévention',
        prevention_desc: 'Informations sur la consommation responsable. Eau gratuite disponible.',
        inclusivity: 'Inclusivité',
        inclusivity_desc: 'Un espace pour TOUS — quelle que soit ton origine, orientation, genre ou style.'
      },
      // App
      app: {
        title: 'L\'APP INVASION LATINA',
        subtitle: 'L\'expérience Invasion dans ta poche',
        download_ios: 'Télécharger sur App Store',
        download_android: 'Disponible sur Google Play',
        feature_coins: 'Invasion Coins',
        feature_coins_desc: 'Gagne des points à chaque événement',
        feature_reservations: 'Réservations',
        feature_reservations_desc: 'Réserve ta table directement',
        feature_dj: 'DJ Song Requests',
        feature_dj_desc: 'Envoie tes demandes au DJ en live',
        feature_qr: 'QR Attendance',
        feature_qr_desc: 'Scan à l\'entrée pour valider ta présence'
      },
      // History
      history: {
        title: 'NOTRE HISTOIRE',
        subtitle: 'Depuis 2009, la familia grandit',
        founders: 'Les Fondateurs',
        founders_desc: 'Née d\'une passion pour la musique latine à Bruxelles',
        loading: 'Chargement de l\'histoire...'
      },
      // Gallery
      gallery: {
        title: 'GALERIE',
        subtitle: 'Revivez nos meilleurs moments',
        all: 'Tous',
        events: 'Événements',
        crowd: 'Ambiance',
        venue: 'Lieux',
        albums: 'Albums Facebook',
        photos: 'Photos',
        category: 'Catégorie',
        view_album: 'Voir l\'album',
        empty: 'Aucune photo disponible pour cette catégorie.'
      },
      // Footer
      footer: {
        tagline: 'Since 2009 • Belgium\'s Biggest Latino Party',
        links: 'Liens rapides',
        contact: 'Contact',
        follow: 'Suivez-nous',
        rights: 'Tous droits réservés',
        privacy: 'Politique de confidentialité',
        terms: 'Conditions d\'utilisation',
        support: 'Support',
        newsletter: 'Reste informe',
        newsletter_placeholder: 'Ton email',
        newsletter_submit: 'S\'abonner',
        newsletter_success: 'Inscrit avec succes !'
      },
      // Cookie Banner
      cookies: {
        message: 'Nous utilisons des cookies pour améliorer votre expérience.',
        accept: 'Accepter',
        reject: 'Refuser',
        customize: 'Personnaliser'
      }
    }
  },
  nl: {
    translation: {
      next_event: {
        "title": "Volgend feest",
        "agenda": "Volledige agenda",
        "loading": "Nieuwe data laden…",
        "error": "De volgende data zijn tijdelijk niet beschikbaar.",
        "retry": "Opnieuw proberen",
        "openair": "Open Air",
        "monthly": "Clubavond",
        "book": "Tickets kopen",
        "sold_out": "Uitverkocht",
        "soon": "Ticketverkoop binnenkort beschikbaar",
        "empty_title": "Nieuwe datum binnenkort bekend",
        "empty_text": "Het volgende feest komt eraan. Hier vind je nieuwe data en tickets zodra ze bekend zijn.",
        "follow": "Volg onze aankondigingen"
      },
      nav: {
        home: 'Home',
        agenda: 'Agenda',
        histoire: 'Geschiedenis',
        videos: 'Video\'s',
        galerie: 'Galerij',
        ideologie: 'Ideologie',
        experience: 'Ervaring',
        booking: 'VIP Reserveren',
        tickets: 'Tickets'
      },
      hero: {
        title: 'INVASION LATINA',
        subtitle: 'OPEN AIR 2026',
        tagline: 'Dit is geen festival. Dit is onze zomer.',
        date: 'Zaterdag 11 Juli',
        location: 'Congresplein • Brussel',
        cta_tickets: 'Koop mijn tickets',
        cta_discover: 'Ontdekken'
      },
      countdown: {
        title: 'Open Air begint over',
        days: 'Dagen',
        hours: 'Uren',
        minutes: 'Minuten',
        seconds: 'Seconden',
        event_started: 'Het evenement is begonnen!'
      },
      tickets: {
        title: 'TICKETS',
        subtitle: 'Verzeker je plek op Open Air 2026',
        sold_out: 'UITVERKOCHT',
        available: 'BESCHIKBAAR',
        coming_soon: 'BINNENKORT',
        buy: 'Kopen'
      },
      experience: {
        title: 'DE ERVARING',
        subtitle: 'Beleef de Invasion',
        music: 'Muziek',
        music_desc: 'Reggaeton, Latin Trap, Afrobeats, Dancehall',
        decor: 'Decor',
        decor_desc: 'Meeslepende scènografie, LED-schermen, verlichting',
        community: 'Gemeenschap',
        community_desc: 'La familia komt samen. 7 000 mensen.',
        years: 'jaar',
        people: 'mensen',
        hours: 'uur muziek',
        one_place: '1 locatie',
        intro_1: 'De Invasion Latina-ervaring is veel meer dan een avondje uit. Het is een totale onderdompeling in de Latijnse cultuur, een moment van pure energie waar',
        intro_familia: 'la familia',
        intro_2: 'samenkomt om onvergetelijke momenten te beleven.',
        sounds_title: 'De geluiden van Invasion',
        stat_years: 'Jaar',
        stat_people: 'Mensen',
        stat_hours: 'Muziek',
        stat_djs: 'DJ\'s',
        cta_title: 'Klaar om de ervaring te beleven?',
        cta_subtitle: 'Sluit je aan bij la familia op 11 juli 2026',
        cta_tickets: 'Mijn tickets →',
        cta_vip: 'VIP reserveren'
      },
      booking: {
        title: 'RESERVEER EEN VIP-TAFEL',
        subtitle: 'Beleef de VIP-ervaring met je groep',
        name: 'Volledige naam',
        email: 'E-mail',
        phone: 'Telefoon (WhatsApp)',
        event: 'Evenement',
        guests: 'Aantal personen',
        message: 'Bericht (optioneel)',
        submit: 'Aanvraag verzenden',
        whatsapp: 'Contact via WhatsApp',
        success: 'Aanvraag succesvol verzonden!',
        error: 'Er is een fout opgetreden. Probeer het opnieuw.'
      },
      videos: {
        title: 'HERBELEEF DE INVASION',
        subtitle: 'Onze beste momenten op video',
        all: 'Alle',
        aftermovies: 'Aftermovies',
        aftermovie: 'Aftermovie',
        teasers: 'Teasers',
        teaser: 'Teaser',
        openair: 'Open Air',
        mirano: 'Mirano',
        all_types: 'Alle types',
        all_categories: 'Alle categorieën',
        type: 'Type',
        category: 'Categorie',
        no_videos: 'Geen video\'s beschikbaar.'
      },
      spotify: {
        title: 'DE PLAYLIST',
        subtitle: 'De sound van Invasion Latina',
        open_in_spotify: 'Luister op Spotify',
        play_button: 'Speel de playlist',
        close: 'Sluiten'
      },
      ideology: {
        title: 'ONZE FILOSOFIE',
        subtitle: 'De Invasion is ook...',
        slogan: 'Respect. Veiligheid. Familia.',
        respect: 'Respect',
        respect_desc: 'Iedereen is welkom, zonder uitzondering. Zero tolerantie voor discriminatie.',
        security: 'Veiligheid',
        security_desc: 'Professioneel beveiligingsteam, decompressieruimtes.',
        consent: 'Toestemming',
        consent_desc: 'Respect voor het lichaam en de ruimte van iedereen is niet-onderhandelbaar.',
        safe_space: 'Safe Space',
        safe_space_desc: 'Voel je je niet goed? Benader ons team (Invasion t-shirt). We zijn er.',
        prevention: 'Preventie',
        prevention_desc: 'Informatie over verantwoord consumeren. Gratis water beschikbaar.',
        inclusivity: 'Inclusiviteit',
        inclusivity_desc: 'Een ruimte voor IEDEREEN — ongeacht afkomst, oriëntatie, geslacht of stijl.'
      },
      app: {
        title: 'DE INVASION LATINA APP',
        subtitle: 'De Invasion-ervaring in je zak',
        download_ios: 'Download op App Store',
        download_android: 'Beschikbaar op Google Play',
        feature_coins: 'Invasion Coins',
        feature_coins_desc: 'Verdien punten bij elk evenement',
        feature_reservations: 'Reserveringen',
        feature_reservations_desc: 'Reserveer je tafel direct',
        feature_dj: 'DJ Song Requests',
        feature_dj_desc: 'Stuur je verzoeken naar de DJ live',
        feature_qr: 'QR Attendance',
        feature_qr_desc: 'Scan bij de ingang om je aanwezigheid te valideren'
      },
      history: {
        title: 'ONS VERHAAL',
        subtitle: 'Sinds 2009 groeit de familia',
        founders: 'De Oprichters',
        founders_desc: 'Geboren uit een passie voor Latijnse muziek in Brussel',
        loading: 'Geschiedenis laden...'
      },
      gallery: {
        title: 'GALERIJ',
        subtitle: 'Herbeleef onze beste momenten',
        all: 'Alle',
        events: 'Evenementen',
        crowd: 'Sfeer',
        venue: 'Locaties',
        albums: 'Facebook Albums',
        photos: 'Foto\'s',
        category: 'Categorie',
        view_album: 'Album bekijken',
        empty: 'Geen foto\'s beschikbaar voor deze categorie.'
      },
      footer: {
        tagline: 'Sinds 2009 • België\'s Grootste Latino Party',
        links: 'Snelle links',
        contact: 'Contact',
        follow: 'Volg ons',
        rights: 'Alle rechten voorbehouden',
        privacy: 'Privacybeleid',
        terms: 'Gebruiksvoorwaarden',
        support: 'Ondersteuning',
        newsletter: 'Blijf op de hoogte',
        newsletter_placeholder: 'Je e-mail',
        newsletter_submit: 'Abonneren',
        newsletter_success: 'Succesvol ingeschreven!'
      },
      cookies: {
        message: 'We gebruiken cookies om uw ervaring te verbeteren.',
        accept: 'Accepteren',
        reject: 'Weigeren',
        customize: 'Aanpassen'
      }
    }
  },
  en: {
    translation: {
      next_event: {
        "title": "Next event",
        "agenda": "Full calendar",
        "loading": "Loading upcoming dates…",
        "error": "Upcoming dates are temporarily unavailable.",
        "retry": "Try again",
        "openair": "Open Air",
        "monthly": "Club night",
        "book": "Get tickets",
        "sold_out": "Sold out",
        "soon": "Tickets available soon",
        "empty_title": "Next date announced soon",
        "empty_text": "The next party is on its way. Find new dates and ticket links here as soon as they are announced.",
        "follow": "Follow our announcements"
      },
      nav: {
        home: 'Home',
        agenda: 'Agenda',
        histoire: 'History',
        videos: 'Videos',
        galerie: 'Gallery',
        ideologie: 'Ideology',
        experience: 'Experience',
        booking: 'Book VIP',
        tickets: 'Tickets'
      },
      hero: {
        title: 'INVASION LATINA',
        subtitle: 'OPEN AIR 2026',
        tagline: "It's not a festival. It's our summer.",
        date: 'Saturday July 11',
        location: 'Congress Square • Brussels',
        cta_tickets: 'Get my tickets',
        cta_discover: 'Discover'
      },
      countdown: {
        title: 'Open Air starts in',
        days: 'Days',
        hours: 'Hours',
        minutes: 'Minutes',
        seconds: 'Seconds',
        event_started: 'The event has started!'
      },
      tickets: {
        title: 'TICKETS',
        subtitle: 'Secure your spot at Open Air 2026',
        sold_out: 'SOLD OUT',
        available: 'AVAILABLE',
        coming_soon: 'COMING SOON',
        buy: 'Buy'
      },
      experience: {
        title: 'THE EXPERIENCE',
        subtitle: 'Live the Invasion',
        music: 'Music',
        music_desc: 'Reggaeton, Latin Trap, Afrobeats, Dancehall',
        decor: 'Decor',
        decor_desc: 'Immersive scenography, LED screens, lights',
        community: 'Community',
        community_desc: 'La familia reunites. 7,000 people.',
        years: 'years',
        people: 'people',
        hours: 'hours of music',
        one_place: '1 venue',
        intro_1: 'The Invasion Latina experience is much more than a night out. It\'s a total immersion into Latin culture, a moment of pure energy where',
        intro_familia: 'la familia',
        intro_2: 'comes together to live unforgettable moments.',
        sounds_title: 'The Sounds of the Invasion',
        stat_years: 'Years',
        stat_people: 'People',
        stat_hours: 'Of music',
        stat_djs: 'DJs',
        cta_title: 'Ready to live the experience?',
        cta_subtitle: 'Join la familia on July 11, 2026',
        cta_tickets: 'Get my tickets →',
        cta_vip: 'Book VIP'
      },
      booking: {
        title: 'BOOK A VIP TABLE',
        subtitle: 'Experience VIP with your group',
        name: 'Full name',
        email: 'Email',
        phone: 'Phone (WhatsApp)',
        event: 'Event',
        guests: 'Number of guests',
        message: 'Message (optional)',
        submit: 'Send request',
        whatsapp: 'Contact via WhatsApp',
        success: 'Request sent successfully!',
        error: 'An error occurred. Please try again.'
      },
      videos: {
        title: 'RELIVE THE INVASION',
        subtitle: 'Our best moments on video',
        all: 'All',
        aftermovies: 'Aftermovies',
        aftermovie: 'Aftermovie',
        teasers: 'Teasers',
        teaser: 'Teaser',
        openair: 'Open Air',
        mirano: 'Mirano',
        all_types: 'All types',
        all_categories: 'All categories',
        type: 'Type',
        category: 'Category',
        no_videos: 'No videos available.'
      },
      spotify: {
        title: 'THE PLAYLIST',
        subtitle: 'The sound of Invasion Latina',
        open_in_spotify: 'Listen on Spotify',
        play_button: 'Play the playlist',
        close: 'Close'
      },
      ideology: {
        title: 'OUR PHILOSOPHY',
        subtitle: 'The Invasion is also...',
        slogan: 'Respect. Safety. Familia.',
        respect: 'Respect',
        respect_desc: 'Everyone is welcome, no exception. Zero tolerance for discrimination.',
        security: 'Security',
        security_desc: 'Professional security team, decompression spaces.',
        consent: 'Consent',
        consent_desc: 'Respect for everyone\'s body and space is non-negotiable.',
        safe_space: 'Safe Space',
        safe_space_desc: 'Feeling unwell? Approach our team (Invasion t-shirt). We\'re here.',
        prevention: 'Prevention',
        prevention_desc: 'Information on responsible consumption. Free water available.',
        inclusivity: 'Inclusivity',
        inclusivity_desc: 'A space for EVERYONE — regardless of origin, orientation, gender or style.'
      },
      app: {
        title: 'THE INVASION LATINA APP',
        subtitle: 'The Invasion experience in your pocket',
        download_ios: 'Download on App Store',
        download_android: 'Available on Google Play',
        feature_coins: 'Invasion Coins',
        feature_coins_desc: 'Earn points at every event',
        feature_reservations: 'Reservations',
        feature_reservations_desc: 'Book your table directly',
        feature_dj: 'DJ Song Requests',
        feature_dj_desc: 'Send your requests to the DJ live',
        feature_qr: 'QR Attendance',
        feature_qr_desc: 'Scan at the entrance to validate your presence'
      },
      history: {
        title: 'OUR HISTORY',
        subtitle: 'Since 2009, la familia grows',
        founders: 'The Founders',
        founders_desc: 'Born from a passion for Latin music in Brussels',
        loading: 'Loading history...'
      },
      gallery: {
        title: 'GALLERY',
        subtitle: 'Relive our best moments',
        all: 'All',
        events: 'Events',
        crowd: 'Atmosphere',
        venue: 'Venues',
        albums: 'Facebook Albums',
        photos: 'Photos',
        category: 'Category',
        view_album: 'View album',
        empty: 'No photos available for this category.'
      },
      footer: {
        tagline: 'Since 2009 • Belgium\'s Biggest Latino Party',
        links: 'Quick links',
        contact: 'Contact',
        follow: 'Follow us',
        rights: 'All rights reserved',
        privacy: 'Privacy Policy',
        terms: 'Terms of Use',
        support: 'Support',
        newsletter: 'Stay informed',
        newsletter_placeholder: 'Your email',
        newsletter_submit: 'Subscribe',
        newsletter_success: 'Successfully subscribed!'
      },
      cookies: {
        message: 'We use cookies to improve your experience.',
        accept: 'Accept',
        reject: 'Reject',
        customize: 'Customize'
      }
    }
  },
  es: {
    translation: {
      next_event: {
        "title": "Próxima fiesta",
        "agenda": "Toda la agenda",
        "loading": "Cargando próximas fechas…",
        "error": "Las próximas fechas no están disponibles temporalmente.",
        "retry": "Reintentar",
        "openair": "Open Air",
        "monthly": "Fiesta en el club",
        "book": "Comprar entradas",
        "sold_out": "Agotado",
        "soon": "Entradas disponibles próximamente",
        "empty_title": "Próxima fecha por anunciar",
        "empty_text": "La próxima fiesta se está preparando. Aquí encontrarás las nuevas fechas y sus entradas en cuanto se anuncien.",
        "follow": "Sigue nuestras novedades"
      },
      nav: {
        home: 'Inicio',
        agenda: 'Agenda',
        histoire: 'Historia',
        videos: 'Videos',
        galerie: 'Galería',
        ideologie: 'Ideología',
        experience: 'Experiencia',
        booking: 'Reservar VIP',
        tickets: 'Tickets'
      },
      hero: {
        title: 'INVASION LATINA',
        subtitle: 'OPEN AIR 2026',
        tagline: 'No es un festival. Es nuestro verano.',
        date: 'Sábado 11 de Julio',
        location: 'Plaza del Congreso • Bruselas',
        cta_tickets: 'Comprar tickets',
        cta_discover: 'Descubrir'
      },
      countdown: {
        title: 'El Open Air comienza en',
        days: 'Días',
        hours: 'Horas',
        minutes: 'Minutos',
        seconds: 'Segundos',
        event_started: 'El evento ha comenzado!'
      },
      tickets: {
        title: 'TICKETS',
        subtitle: 'Asegura tu lugar en el Open Air 2026',
        sold_out: 'AGOTADO',
        available: 'DISPONIBLE',
        coming_soon: 'PRÓXIMAMENTE',
        buy: 'Comprar'
      },
      experience: {
        title: 'LA EXPERIENCIA',
        subtitle: 'Vive la Invasion',
        music: 'Música',
        music_desc: 'Reggaeton, Latin Trap, Afrobeats, Dancehall',
        decor: 'Decoración',
        decor_desc: 'Escenografía inmersiva, pantallas LED, luces',
        community: 'Comunidad',
        community_desc: 'La familia se reúne. 7 000 personas.',
        years: 'años',
        people: 'personas',
        hours: 'horas de música',
        one_place: '1 lugar',
        intro_1: 'La experiencia Invasion Latina es mucho más que una fiesta. Es una inmersión total en la cultura latina, un momento de pura energía donde',
        intro_familia: 'la familia',
        intro_2: 'se reúne para vivir momentos inolvidables.',
        sounds_title: 'Los sonidos de la Invasión',
        stat_years: 'Años',
        stat_people: 'Personas',
        stat_hours: 'De música',
        stat_djs: 'DJs',
        cta_title: '¿Listo para vivir la experiencia?',
        cta_subtitle: 'Únete a la familia el 11 de julio de 2026',
        cta_tickets: 'Conseguir mis tickets →',
        cta_vip: 'Reservar VIP'
      },
      booking: {
        title: 'RESERVAR MESA VIP',
        subtitle: 'Vive la experiencia VIP con tu grupo',
        name: 'Nombre completo',
        email: 'Correo electrónico',
        phone: 'Teléfono (WhatsApp)',
        event: 'Evento',
        guests: 'Número de personas',
        message: 'Mensaje (opcional)',
        submit: 'Enviar solicitud',
        whatsapp: 'Contactar por WhatsApp',
        success: '¡Solicitud enviada con éxito!',
        error: 'Ocurrió un error. Por favor, inténtalo de nuevo.'
      },
      videos: {
        title: 'REVIVE LA INVASION',
        subtitle: 'Nuestros mejores momentos en video',
        all: 'Todos',
        aftermovies: 'Aftermovies',
        aftermovie: 'Aftermovie',
        teasers: 'Teasers',
        teaser: 'Teaser',
        openair: 'Open Air',
        mirano: 'Mirano',
        all_types: 'Todos los tipos',
        all_categories: 'Todas las categorías',
        type: 'Tipo',
        category: 'Categoría',
        no_videos: 'No hay videos disponibles.'
      },
      spotify: {
        title: 'LA PLAYLIST',
        subtitle: 'El sonido de Invasion Latina',
        open_in_spotify: 'Escuchar en Spotify',
        play_button: 'Escuchar la playlist',
        close: 'Cerrar'
      },
      ideology: {
        title: 'NUESTRA FILOSOFÍA',
        subtitle: 'La Invasion también es...',
        slogan: 'Respeto. Seguridad. Familia.',
        respect: 'Respeto',
        respect_desc: 'Todos son bienvenidos, sin excepción. Tolerancia cero con la discriminación.',
        security: 'Seguridad',
        security_desc: 'Equipo de seguridad profesional, espacios de descompresión.',
        consent: 'Consentimiento',
        consent_desc: 'El respeto al cuerpo y espacio de cada persona es innegociable.',
        safe_space: 'Safe Space',
        safe_space_desc: '¿Te sientes mal? Acude a nuestro equipo (camiseta Invasion). Estamos aquí.',
        prevention: 'Prevención',
        prevention_desc: 'Información sobre consumo responsable. Agua gratuita disponible.',
        inclusivity: 'Inclusividad',
        inclusivity_desc: 'Un espacio para TODOS — sin importar origen, orientación, género o estilo.'
      },
      app: {
        title: 'LA APP INVASION LATINA',
        subtitle: 'La experiencia Invasion en tu bolsillo',
        download_ios: 'Descargar en App Store',
        download_android: 'Disponible en Google Play',
        feature_coins: 'Invasion Coins',
        feature_coins_desc: 'Gana puntos en cada evento',
        feature_reservations: 'Reservas',
        feature_reservations_desc: 'Reserva tu mesa directamente',
        feature_dj: 'DJ Song Requests',
        feature_dj_desc: 'Envía tus peticiones al DJ en vivo',
        feature_qr: 'QR Attendance',
        feature_qr_desc: 'Escanea en la entrada para validar tu presencia'
      },
      history: {
        title: 'NUESTRA HISTORIA',
        subtitle: 'Desde 2009, la familia crece',
        founders: 'Los Fundadores',
        founders_desc: 'Nacida de una pasión por la música latina en Bruselas',
        loading: 'Cargando historia...'
      },
      gallery: {
        title: 'GALERÍA',
        subtitle: 'Revive nuestros mejores momentos',
        all: 'Todos',
        events: 'Eventos',
        crowd: 'Ambiente',
        venue: 'Lugares',
        albums: 'Álbumes de Facebook',
        photos: 'Fotos',
        category: 'Categoría',
        view_album: 'Ver álbum',
        empty: 'No hay fotos disponibles para esta categoría.'
      },
      footer: {
        tagline: 'Desde 2009 • La Fiesta Latina Más Grande de Bélgica',
        links: 'Enlaces rápidos',
        contact: 'Contacto',
        follow: 'Síguenos',
        rights: 'Todos los derechos reservados',
        privacy: 'Política de Privacidad',
        terms: 'Condiciones de Uso',
        support: 'Soporte',
        newsletter: 'Mantente informado',
        newsletter_placeholder: 'Tu email',
        newsletter_submit: 'Suscribirse',
        newsletter_success: 'Suscrito con exito!'
      },
      cookies: {
        message: 'Usamos cookies para mejorar tu experiencia.',
        accept: 'Aceptar',
        reject: 'Rechazar',
        customize: 'Personalizar'
      }
    }
  }
};

// Remember user language between visits + tabs
const STORAGE_KEY = 'invasion-latina-lang';
const SUPPORTED = ['fr', 'nl', 'en', 'es'];
let initialLang = 'fr';
try {
  const saved = typeof window !== 'undefined' ? window.localStorage.getItem(STORAGE_KEY) : null;
  if (saved && SUPPORTED.includes(saved)) initialLang = saved;
} catch (_) { /* localStorage disabled */ }

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLang,
    fallbackLng: 'fr',
    supportedLngs: SUPPORTED,
    interpolation: {
      escapeValue: false
    }
  });

// Persist on change so reloads / navigation keep the choice
i18n.on('languageChanged', (lng) => {
  try {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(STORAGE_KEY, lng);
      document.documentElement.lang = lng;
    }
  } catch (_) { /* ignore */ }
});

// Set initial <html lang="…">
if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLang;
}

export default i18n;
